const REASONS = [
  { icon: 'ri-checkbox-circle-line', title: 'Clean Job Sites — Always', desc: 'We leave your home cleaner than we found it. Every single time.' },
  { icon: 'ri-grid-line', title: 'Subfloor-First Approach', desc: 'We fix the foundation before installing anything on top.' },
  { icon: 'ri-time-line', title: 'No Rushed Installs', desc: 'Quality takes time. We don\'t cut corners to go faster.' },
  { icon: 'ri-message-2-line', title: 'Clear Communication', desc: 'You\'re updated at every step — no surprises, no guessing.' },
  { icon: 'ri-building-line', title: 'Built for Long-Term Results', desc: 'Our work is meant to last years, not just pass inspection.' },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-[#f4f0ea] py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-4">Our Difference</p>
            <h2 className="text-4xl md:text-5xl font-black text-[#1c1a17] leading-tight mb-6">
              Why Choose <br />
              <span className="text-[#c9a55a]">VM Construction</span>
            </h2>
            <div className="w-16 h-1 bg-[#c9a55a] rounded-full mb-8" />
            <p className="text-[#6b6560] text-base leading-relaxed max-w-lg">
              We don&apos;t just show up and install. We assess, prepare, and execute with the precision that your home deserves.
            </p>

            {/* Image */}
            <div className="mt-10 rounded-2xl overflow-hidden w-full h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/c2f8d859540c3686c7dea0b624fc454b.jpg"
                alt="VM Construction professional team Tampa Bay"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right — Reasons List */}
          <div className="flex flex-col gap-5">
            {REASONS.map((reason) => (
              <div
                key={reason.title}
                className="group flex items-start gap-5 bg-white hover:bg-white border border-[#e5e0d8] hover:border-[#c9a55a]/40 rounded-xl p-6 transition-all duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#c9a55a]/10 rounded-xl flex-shrink-0">
                  <i className={`${reason.icon} text-[#c9a55a] text-xl`} />
                </div>
                <div>
                  <h3 className="text-[#1c1a17] font-bold text-base mb-1">{reason.title}</h3>
                  <p className="text-[#6b6560] text-sm leading-relaxed">{reason.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
